import { render, staticRenderFns } from "./zhuanti-xiandaijinrong.vue?vue&type=template&id=037a2bb0&"
import script from "./zhuanti-xiandaijinrong.vue?vue&type=script&lang=js&"
export * from "./zhuanti-xiandaijinrong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports